module.exports = __webpack_public_path__ + "img/permission.33b1195f.png";